// 1つめの引数idはnumberだがstringに変換する必要もない為変換しない
export type BitfinexTradeData = [string, number, number, number];
// idはnumberだがstringに変換する必要もない為変換しない
export interface BitflyerTradeData {
  id: string;
  side: string;
  price: number;
  size: number;
  exec_date: string;
}
export enum TickDirection {
  PlusTick = 'PlusTick',
  MinusTick = 'MinusTick',
  ZeroPlusTick = 'ZeroPlusTick',
  ZeroMinusTick = 'ZeroMinusTick',
}
export interface BitmexTradeData {
  trdMatchID: string;
  side: string;
  price: number;
  size: number;
  tickDirection: TickDirection;
  timestamp: string;
}
export enum Side {
  BUY = 'BUY',
  SELL = 'SELL',
}
export enum Exchange {
  Bitfinex = 'bitfinex',
  Bitflyer = 'bitflyer',
  Bitmex = 'bitmex',
}
export interface Trade {
  id: string;
  exchange: Exchange;
  side: Side;
  price: number;
  size: number;
  direction?: number;
  timestamp: number;
}
export interface AlertData {
  exchange: Exchange;
  side: Side;
  size: number;
  timestamp: number;
}
export interface VolumePerPeriod {
  timestamp: number;
  size: number;
}
export interface VolumeHistory {
  BUY: VolumePerPeriod[];
  SELL: VolumePerPeriod[];
}

